module.exports = __webpack_public_path__ + "static/img/case_lore.c5daba95.png";